import React, { ButtonHTMLAttributes, ComponentType } from 'react';
import { styled } from '@mui/material/styles';

const BulkOperationButton: ComponentType<ButtonHTMLAttributes<HTMLButtonElement>> = styled('button')({
  paddingRight: '12px',
  paddingLeft: '8px',
  gap: '4px',
  display: 'flex',
  alignItems: 'center',
  color: '#344563',
  fontWeight: 400,
  fontSize: '12px',
  borderRadius: '6px',
  border: '1px solid #0065FF',
  background: '#FFFFFF',
  height: '32px',

  '&:disabled': {
    filter: 'saturate(0) opacity(0.85)',
    cursor: 'default',
  },

  '&>*': {
    flexShrink: 0
  }
});

export default BulkOperationButton;